var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgLlamadaIcono = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.042,
    height: 20.934,
    viewBox: "0 0 22.042 20.934",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#000;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.738,14.416a1.282,1.282,0,0,0-1.58-.023L14.74,15.623c-.165.017-1.114-.051-3.961-2.9l-.47-.47C7.7,9.641,7.413,8.717,7.387,8.5l.946-.945a1.29,1.29,0,0,0,0-1.607L5.511,3.128a1.154,1.154,0,0,0-.8-.278,1.152,1.152,0,0,0-.811.288L.075,7.16l.185.308A48.137,48.137,0,0,0,16.235,22.5l.3.171,4.023-3.822a1.287,1.287,0,0,0,0-1.607Z",
    transform: "translate(0.55 -2.35)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLlamadaIcono, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/llamada_icono.ed62c2f4.svg";
export { ForwardRef as ReactComponent };